import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";

import { auth } from './auth.module';
import { search } from './search.module';
import { toaster } from './toaster.module';
import { drawer } from './drawer.module';
import { reports } from './reports.module';
import { loader } from './loader.module';
import { exchange } from './exchange.module';
import { general } from './general.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth, search, toaster, drawer, reports,loader,exchange,general
  },
  plugins: [createPersistedState()]
});



// WEBPACK FOOTER //
// ./src/store/index.js